import { render, staticRenderFns } from "./StatusPageLink.vue?vue&type=template&id=355d7330&scoped=true&"
import script from "./StatusPageLink.vue?vue&type=script&lang=js&"
export * from "./StatusPageLink.vue?vue&type=script&lang=js&"
import style0 from "./StatusPageLink.vue?vue&type=style&index=0&id=355d7330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355d7330",
  null
  
)

export default component.exports